<template>
  <div>
    <app-page-title>
      <template #pageTitleLeft>
        <h1>Administrator Management</h1>
      </template>
      <template #pageTitleRight>
        <div class="_text-right">
          <button class="btn --sm" @click="onAddAdminClick">Add an Administrator</button>
        </div>
      </template>
    </app-page-title>

    <cloud-cannon-content
      class="_p0 _ptxs bg-light-gray"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.header"
    />

    <app-advanced-table-section
      class="_bt1"
      :loading="recentlyAddedUsersLoading"
      title="Recently Added Administrators"
      :headers="recentlyAddedUsersHeaders"
      id="recently-added"
      :items="recentlyAddedUsers"
      :clickable="true"
      :noDataText="recentlyAddedUsersMessage"
      @cellClicked="cellClicked">
        <template #actions>
          <app-column-picker
            :headers='recentlyAddedUsersHeaders'
            @updateHeaders="updateHeaders('recentlyAddedUsersHeaders', $event)"
            />
        </template>
    </app-advanced-table-section>

    <app-advanced-table-section
      class="_bt1"
      :loading="recentlyUpdatedUsersLoading"
      title="Recently Updated Administrators"
      :headers="recentlyUpdatedUsersHeaders"
      id="recently-updated"
      :items="recentlyUpdatedUsers"
      :clickable="true"
      :noDataText="recentlyUpdatedUsersMessage"
      @cellClicked="cellClicked">
        <template #actions>
          <app-column-picker
            :headers='recentlyAddedUsersHeaders'
            @updateHeaders="updateHeaders('recentlyUpdatedUsersHeaders', $event)"
            />
        </template>
    </app-advanced-table-section>

    <app-advanced-table-section
      class="_bt1"
      :loading="pendingUsersLoading"
      title="Registration Pending Administrators"
      :headers="pendingUsersHeaders"
      id="registration-pending"
      :items="pendingUsers"
      :noDataText="pendingUsersMessage"
      :clickable="true"
      @cellClicked="cellClicked">
        <template #actions>
          <app-column-picker
            :headers='pendingUsersHeaders'
            @updateHeaders="updateHeaders('pendingUsersHeaders', $event)"
            />
        </template>
    </app-advanced-table-section>

    <cloud-cannon-content
      class="_p0 _ptxs _pbxs bg-light-gray"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.footer"
    />
  </div>
</template>

<script>
  import AppAdvancedTableSection from '@sections/AdvancedTableSection'
  import AppColumnPicker from '@molecules/ColumnPicker'
  import AppPageTitle from '@sections/PageTitle'

  import { mapGetters } from 'vuex'
  import * as actionTypes from '@store/modules/userManagement/actionTypes'
  import fetchable from '@mixins/fetchable'
  import formattable from '@mixins/formattable'
  import CloudCannonable from '@mixins/CloudCannonable'

  export default {
    mixins: [
      fetchable,
      formattable,
      CloudCannonable
    ],
    components: {
      AppAdvancedTableSection,
      AppColumnPicker,
      AppPageTitle
    },
    data() {
      return {
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/administrator-management.json'
            },
            config: {
              root: true
            }
          },
          {
            action: actionTypes.GET_RECENTLY_ADDED_USERS
          },
          {
            action: actionTypes.GET_RECENTLY_UPDATED_USERS
          },
          {
            action: actionTypes.GET_PENDING_USERS
          }
        ],
        recentlyAddedUsersHeaders: [
          { text: 'User Name', align: 'left', value: 'userName' },
          { text: 'User ID', value: 'userId' },
          { text: 'Email Address', value: 'email' },
          { text: 'Date Added', value: 'date' }
        ],
        recentlyUpdatedUsersHeaders: [
          { text: 'User Name', align: 'left', value: 'userName' },
          { text: 'User ID', value: 'userId' },
          { text: 'Email Address', value: 'email' },
          { text: 'Date Updated', value: 'date' }
        ],
        pendingUsersHeaders: [
          { text: 'User Name', align: 'left', value: 'userName' },
          { text: 'User ID', value: 'userId' },
          { text: 'Email Address', value: 'email' },
          { text: 'Date Invited', value: 'date' }
        ]

      }
    },
    methods: {
      onAddAdminClick() {
        this.$store.commit('users2/CREATE_NEW_USER');
        this.$router.push({name: 'user-add'});
      },
      updateHeaders(headerName, headers) {
        this.headers = this.$set(this, headerName, headers)
      },
      cellClicked(info) {
        this.$router.push({ name: 'user-view', params: { 'userId': info.userId } })
      }
    },
    computed: {
      ...mapGetters([
        'recentlyAddedUsersLoading',
        'recentlyAddedUsers',
        'recentlyAddedUsersMessage',
        'recentlyUpdatedUsersLoading',
        'recentlyUpdatedUsers',
        'recentlyUpdatedUsersMessage',
        'pendingUsersLoading',
        'pendingUsers',
        'pendingUsersMessage'
      ])
    }
  }
</script>
